import { makeStyles } from '@fluentui/react-components';

export const useStyles = makeStyles({
  input: {
    minWidth: '220px',
    flex: '1',
  },
});
